import { render, staticRenderFns } from "./IconThumbUpOutline.vue?vue&type=template&id=2bd270f8"
import script from "./IconThumbUpOutline.vue?vue&type=script&lang=js"
export * from "./IconThumbUpOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports